import { render, staticRenderFns } from "./FormularioResultadoComponent.vue?vue&type=template&id=6112690e&"
import script from "./FormularioResultadoComponent.vue?vue&type=script&lang=ts&"
export * from "./FormularioResultadoComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioResultadoComponent.vue?vue&type=style&index=0&id=6112690e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports